import { AccredibleChipComponentModule } from '@accredible-frontend-v2/components/chip';
import {
  AccredibleIcon,
  AccredibleIconType,
  ActiveFeatureFlags,
  WalletCredential,
} from '@accredible-frontend-v2/models';
import { AccredibleRecipientFeatureFlagsService } from '@accredible-frontend-v2/services/feature-flags';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoModule } from '@jsverse/transloco';
import { CredentialVerificationLevelComponent } from '@recipient-portal/ui-common';
import { map } from 'rxjs/operators';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    AccredibleChipComponentModule,
    TranslocoModule,
    CredentialVerificationLevelComponent,
  ],
  selector: 'accredible-credential-tile-status',
  templateUrl: 'credential-tile-status.component.html',
  styleUrls: ['./credential-tile-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CredentialTileStatusComponent {
  credential = input<WalletCredential>();

  // TODO(Kanishka): Remove this after OB3 import release
  private readonly _recipientFeatureFlags = inject(AccredibleRecipientFeatureFlagsService);
  isOb3ImportEnabled = toSignal(
    this._recipientFeatureFlags
      .loadFeatureFlags()
      .pipe(map((features) => features[ActiveFeatureFlags.OB3_W3C_IMPORT])),
  );

  unverifiedIcon: AccredibleIcon = {
    type: AccredibleIconType.ACC,
    name: 'acc-icon-unverified',
    rtlMirror: true,
  };
  privateIcon: AccredibleIcon = {
    type: AccredibleIconType.MAT,
    name: 'visibility_off',
  };
  expiredIcon: AccredibleIcon = {
    type: AccredibleIconType.MAT,
    name: 'warning',
  };
}
